import axios from 'axios';
import { LOGIN_URL } from "../config/rest_endpoints";
import { Notifications } from '../components/common/notification';
import { DATA_KEY } from './globalKeys';
import { getUser } from './session';
import { ADDITIONAL_ACCOUNT_INFO, REPORTS_BASE_URL, ROUTING_BASE_URL, CARRIER, CDR_BILLING, ACCOUNT_DASHBOARD, CARRIER_DASHBOARD, INVOICE_BASE_URL, INVOICE_AGENT_BASE_URL, INVOICE_BASE, CREATE_RATEDECK_URL, ROUTE_BASE_URL, RATEDECK_URL,CALL_RESTRICTION, FIND_ROUTE_URL, MEDIA_ROUTING_URL, REPORTS_TRAFFIC_STATS } from '../components/routers/RouteConstants';
export const ACTIVE_USER = "save_user";



/**
 * Validate the user
 * ----------------------
 * 
 * @param {*} loginDetails : {username, password}
 */
export function login(loginDetails) {
    return function (dispatch) {
        let body = {
            email: loginDetails.username,
            password: loginDetails.password,
            isAdmin:true
        }
        let header = { headers: { 'Content-Type': 'application/json' } }
        let error = () => Notifications.notify("Unable to Authorized User", "error", "error");

        axios.post(LOGIN_URL, body, header).then(res => {
            console.log('res', res)
            let token = res.headers['x_auth_token'];
            if (res.status === 200) {
                res = {
                    ...res.data.data,
                    "permissions": `/,/accounts,${ADDITIONAL_ACCOUNT_INFO},${CARRIER},${CDR_BILLING},
                        ${REPORTS_BASE_URL}/,${REPORTS_BASE_URL}/balance,${REPORTS_BASE_URL}/account-stats,${REPORTS_BASE_URL}/carrier-stats,${REPORTS_BASE_URL}/account-rejection,${CARRIER}/gateways,/agents-list,/subject-block,${ACCOUNT_DASHBOARD},${CARRIER_DASHBOARD},
                        ${INVOICE_BASE_URL},${INVOICE_BASE},${INVOICE_AGENT_BASE_URL},${ROUTE_BASE_URL},${CREATE_RATEDECK_URL},${CALL_RESTRICTION},${FIND_ROUTE_URL},${MEDIA_ROUTING_URL},${REPORTS_TRAFFIC_STATS}`,
                    "token": token
                }
                res = { [DATA_KEY]: res }
                dispatch({
                    type: ACTIVE_USER,
                    payload: res
                })
            }
            else {
                error()
            }
        }).catch(_ => {
            error()
        })
    }

}



/**
 *  Get the user Details
 * ------------------------
 * 
 */
export function fetchUser() {
    return function (dispatch) {
        let res = getUser()
        res = { [DATA_KEY]: res }

        dispatch({
            type: ACTIVE_USER,
            payload: res
        })
    }
}